"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextualSearch = exports.AutoComplete = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _input = require("../../atoms/input");

var _dropdown = require("../dropdown");

var _Search = require("./Search.styles");

var _ = require("../../");

var _keyPress = _interopRequireDefault(require("../../hooks/key-press"));

var _clickOutside = _interopRequireDefault(require("../../hooks/click-outside"));

var _iconButton = require("../../atoms/icon-button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ContextualSearch = ({
  inputProps,
  dropdownProps,
  showDropdown = true
}) => {
  return /*#__PURE__*/_react.default.createElement(_Search.StyledCSearch, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "column left"
  }, /*#__PURE__*/_react.default.createElement(_input.Input, inputProps)), showDropdown ? /*#__PURE__*/_react.default.createElement("div", {
    className: "column right"
  }, /*#__PURE__*/_react.default.createElement(_dropdown.Dropdown, dropdownProps)) : null);
};

exports.ContextualSearch = ContextualSearch;
ContextualSearch.propTypes = {
  inputProps: _propTypes.default.shape({
    error: _propTypes.default.bool,
    errorMessage: _propTypes.default.string,
    label: _propTypes.default.string,
    icon: _propTypes.default.string,
    boxed: _propTypes.default.bool,
    className: _propTypes.default.string,
    inputProps: _propTypes.default.shape({
      defaultValue: _propTypes.default.string,
      onBlur: _propTypes.default.func,
      onFocus: _propTypes.default.func,
      onChange: _propTypes.default.func,
      type: _propTypes.default.string,
      value: _propTypes.default.string,
      placeholder: _propTypes.default.string
    }),
    errorProps: _propTypes.default.object,
    kind: _propTypes.default.string
  }),
  dropdownProps: _propTypes.default.shape({
    isDefault: _propTypes.default.bool,
    titleLabel: _propTypes.default.string.isRequired,
    className: _propTypes.default.string,
    options: _propTypes.default.array.isRequired,
    value: _propTypes.default.object,
    onSelect: _propTypes.default.func
  }),
  showDropdown: _propTypes.default.bool
};

const AutoComplete = ({
  inputProps,
  autoCompleteProps,
  children
}) => {
  const {
    isLoading,
    data,
    show,
    onSelect,
    onSearchAll,
    toggleSearchAll,
    onClearSearch,
    onEscPress,
    onBodyClick,
    ...rest
  } = autoCompleteProps;
  const {
    value
  } = inputProps.inputProps;
  const escPress = (0, _keyPress.default)('Escape');
  const clickRef = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    if (escPress) {
      if (typeof onEscPress === 'function') onEscPress();
    }
  }, [escPress, onEscPress]);
  (0, _clickOutside.default)(clickRef, () => {
    if (typeof onBodyClick === 'function') onBodyClick();
  }, [onBodyClick]);
  const handleClick = (0, _react.useCallback)((event, item) => {
    event.preventDefault();

    if (typeof onSelect === 'function') {
      onSelect(item);
    }
  }, [onSelect]);

  const handleClear = e => {
    onClearSearch(e);
  };

  return /*#__PURE__*/_react.default.createElement(_Search.StyledCSearch, {
    ref: clickRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ac-input-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_input.Input, inputProps), value.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ac-icon-right"
  }, /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    icon: "Close",
    iconSize: 14,
    isRounded: true,
    buttonSize: "24px",
    onClick: e => handleClear(e)
  }))), show ? /*#__PURE__*/_react.default.createElement(_Search.StyledAutoComplete, rest, children ? children : isLoading ? /*#__PURE__*/_react.default.createElement(_.Loading, {
    className: "autocomplete-loader",
    show: true
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "head"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col left"
  }, data.sectionTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "col right"
  }, toggleSearchAll ? /*#__PURE__*/_react.default.createElement(_.Link, {
    text: "Seach All",
    href: "",
    type: "secondary",
    onClick: event => onSearchAll(event)
  }) : null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, data.results.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "rows",
      key: index,
      onClick: event => handleClick(event, item)
    }, item.image && /*#__PURE__*/_react.default.createElement("div", {
      className: "cols img"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: item.image,
      alt: item.name
    })), item.sku && /*#__PURE__*/_react.default.createElement("div", {
      className: "cols sku"
    }, item.sku), item.name && /*#__PURE__*/_react.default.createElement("div", {
      className: "cols name"
    }, item.name), item.tags && /*#__PURE__*/_react.default.createElement("div", {
      className: "cols tags"
    }, item.tags));
  })))) : null);
};

exports.AutoComplete = AutoComplete;
AutoComplete.propTypes = {
  inputProps: _propTypes.default.shape({
    error: _propTypes.default.bool,
    errorMessage: _propTypes.default.string,
    label: _propTypes.default.string,
    icon: _propTypes.default.string,
    boxed: _propTypes.default.bool,
    className: _propTypes.default.string,
    inputProps: _propTypes.default.shape({
      defaultValue: _propTypes.default.string,
      onBlur: _propTypes.default.func,
      onFocus: _propTypes.default.func,
      onChange: _propTypes.default.func,
      type: _propTypes.default.string,
      value: _propTypes.default.string,
      placeholder: _propTypes.default.string
    }),
    errorProps: _propTypes.default.object,
    kind: _propTypes.default.string
  }),
  autoCompleteProps: _propTypes.default.shape({
    isLoading: _propTypes.default.bool,
    show: _propTypes.default.bool,
    onSelect: _propTypes.default.func,
    data: _propTypes.default.object,
    onSearchAll: _propTypes.default.func,
    toggleSearchAll: _propTypes.default.bool,
    onClearSearch: _propTypes.default.func,
    onEscPress: _propTypes.default.func,
    onBodyClick: _propTypes.default.func,
    rest: _propTypes.default.object
  }),
  children: _propTypes.default.element
};